import { SharedLocale, type SharedLocalizedString } from "../SharedLocale.js";

export const aboutPathMap = {
	[SharedLocale.cs]: "o-nas",
	[SharedLocale.en]: "about",
	[SharedLocale.pl]: "o-nas",
	[SharedLocale.sk]: "o-nas",
} satisfies SharedLocalizedString;
